<div class="row">
  <div class="col-12 mb-4">
    <div class="card rounded-top-left-0">
      <div class="card-header d-flex justify-start items-center gap-2">
        <h3>Lista de Ubicaciones</h3>

        <span
          class="a-hover font-bold text-primary cursor-pointer"
          (click)="openModal()">
          <i class="fa fa-plus"></i> Agregar Ubicación
        </span>
      </div>

      <div class="card-body">
        <div *ngIf="places.length === 0 && !loading">
          <p class="muted">
            <i class="fa fa-circle-info"></i> No hay ubicaciones registradas
          </p>
        </div>

        <div class="row" id="options-other-filters">
          <div class="col-sm form-group">
            <label for="filter" class="form-label">Filtrar</label>

            <div class="input-group input-group-sm">
              <input
                type="text"
                id="filter"
                [(ngModel)]="filterWord"
                (input)="onInputChange($event)"
                placeholder="Filtra ubicación por nombre"
                name="filter"
                class="form-control"
              />
              <button class="btn btn-primary" (click)="searching()">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>

        <p class="muted">
          <i class="fa fa-circle-info"></i> Selecciona una ubicación
        </p>

        <div class="row">
          <div class="mb-4">
            <table class="table table-hover table-responsive table-bordered">
              <thead>
                <tr>
                  <th class="text-center">Activo</th>
                  <th>Nombre</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngFor="let item of pagination.filter">
                  <tr>
                    <td class="td-center">
                      <i
                        *ngIf="!updatingActive[item.id]"
                        tooltip="Activa/Desactiva estado de la ubicación"
                        (click)="setActivePlace(item)"
                        [ngClass]="item.active ? 'fa-toggle-on text-success' : 'fa-toggle-off'"
                        class="fa active clickeable">
                      </i>

                      <span
                        *ngIf="updatingActive[item.id]"
                        [ngClass]="item.active ? 'text-secondary' : 'text-success'"
                        class="spinner-border spinner-border-sm">
                      </span>
                    </td>

                    <td
                      [class.bg-blue-50]="item.id == placeSelectedId"
                      [class.font-bold]="item.id == placeSelectedId"
                      (click)="setPlaceSelected(item)"
                      style="cursor:pointer;"
                    >
                      <div class="input-group-sm d-flex flex-row" *ngIf="editPlace[item.id]">
                        <input
                          type="text"
                          placeholder="Nombre"
                          class="form-control"
                          [(ngModel)]="item.name"
                        />

                        <button
                          class="btn btn-success"
                          (click)="updatePlace(item); $event.stopPropagation();"
                          [disabled]="loadingUpdate[item.id]">

                          <i class="fa fa-save" *ngIf="!loadingUpdate[item.id]"></i>
                          <span class="spinner-border spinner-border-sm" *ngIf="loadingUpdate[item.id]"></span>
                        </button>
                      </div>

                      <div *ngIf="!editPlace[item.id]">
                        {{ item.name }}
                      </div>
                    </td>

                    <td
                      class="text-right"
                      [class.bg-blue-50]="item.id == placeSelectedId"
                      [class.font-bold]="item.id == placeSelectedId"
                    >
                      <div class="d-flex flex-wrap items-center justify-center gap-1">
                        <span class="a-hover" (click)="editingName(item); $event.stopPropagation();">
                          <i class="fa fa-edit text-primary"></i>
                        </span>
                      </div>
                    </td>
                  </tr>

                  <tr class="tr-middle" *ngIf="loading">
                    <td colspan="3">
                      <app-loading-animation [height]="'5rem'"></app-loading-animation>
                      <p class="display-6">Cargando</p>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <app-pagination-custom [elements]="pagination"></app-pagination-custom>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-dialog
  *ngIf="showModalCreate"
  [show]="showModalCreate"
  [title]="'Agregar ubicación'"
  [showHeader]="true"
  [size]="'md'"
  (closed)="closeModal($event)"
>
  <div modal-body>
    <div class="input-group col mb-4">
      <input
        type="text"
        placeholder="Nombre"
        class="form-control"
        [(ngModel)]="placeName"
      />
    </div>

    <div class="input-group col justify-end text-left">
      <ng-container *ngIf="loadingCreate">
        <button class="btn btn-success" [disabled]="loadingCreate">
          <i class="fa fa-spinner"></i> Agregando
        </button>
      </ng-container>

      <ng-container *ngIf="!loadingCreate">
        <button class="btn btn-success" (click)="addPlace()">
          <i class="fa fa-floppy-disk"></i> Agregar
        </button>
      </ng-container>
    </div>
  </div>
</app-modal-dialog>
